/* eslint-disable react/no-array-index-key */
import * as React from 'react';

import { Form } from 'antd';
import { CloseOutlined, Space, Spacing } from 'farmhub-ui-core';

import {
  CSelect,
  GroupTag,
  NameText,
  OrderStatus,
  OrderTable,
  SearchTable,
} from 'components';
import { theme } from 'styled';
import { SELECT_MODE, SIZE } from 'utils/constants';

import {
  WrapperFilter,
  WrapperIcon,
  WrapperStatus,
  WrapperTagsFilter,
} from './styles';

interface DataItem {
  loading?: boolean;
  name: string;
  list?: any;
  placeholder?: string;
  mode?: 'multiple' | 'tags' | undefined;
  disabled?: boolean;
  width?: string | number;
  dropdownStyle?: React.CSSProperties;
  dropdownMatchSelectWidth?: boolean | number;
}

interface FilterTableProps {
  name: string;
  searchName?: string;
  searchPlaceholder?: string;
  searchOnChange?: boolean;
  form: any;
  isDisplayFilter: boolean;
  data: DataItem[];
  extraAction?: React.ReactNode;
  extraFilter?: React.ReactNode;
  filterTagInfo?: any;
  padding?: string;
  handleFilterFormChange?: (e: any) => void;
  borderBottom?: boolean;
  searchWidth?: number;
  filterStatusWidth?: number;
  width?: string;
  filterWidth?: string;
  size?: SIZE;
  initDataDefault?: (string | number)[];
  background?: string;
  initFilterMultiKey?: string[];
  spacing?: number;
  positionExtraAction?: 'LEFT' | 'RIGHT';
}

const FilterTable = ({
  name,
  searchName,
  searchPlaceholder,
  searchOnChange,
  isDisplayFilter,
  data,
  form,
  padding,
  extraAction,
  extraFilter,
  filterTagInfo,
  handleFilterFormChange,
  borderBottom = true,
  searchWidth,
  filterStatusWidth = 400,
  size = SIZE.SMALL,
  initDataDefault = [],
  width = '100%',
  filterWidth = '180px',
  background = 'ffffff',
  initFilterMultiKey = [],
  spacing = 12,
  positionExtraAction = 'LEFT',
}: FilterTableProps): JSX.Element => {
  const [currentTags, setCurrentTags] = React.useState<string[]>(['all']);

  const handleChooseTag = (value: string) => {
    let newCurrentTags = [...currentTags];

    if (value === 'all') {
      newCurrentTags = ['all'];
    } else {
      if (newCurrentTags.includes('all')) {
        newCurrentTags.shift();
      }

      if (newCurrentTags.includes(value)) {
        if (currentTags.length === 1) {
          return;
        }
        newCurrentTags = newCurrentTags.filter(item => item !== value);
      } else {
        newCurrentTags.push(value);
      }
    }
    handleFilterFormChange &&
      handleFilterFormChange({
        [filterTagInfo.name]: newCurrentTags,
      });
    setCurrentTags(newCurrentTags);
  };

  const handleChangeFilter = (e = {}) => {
    const key = Object.keys(e)[0];
    const value: any = Object.values(e)[0];
    let newValue = e;

    if (Array.isArray(value)) {
      if (value.length === 0) {
        newValue = {
          [key]: initDataDefault,
        };
        form.setFieldsValue(newValue);
      } else {
        const lastValue = value[value.length - 1];
        if (lastValue === 'all') {
          form.setFieldsValue({ [key]: ['all'] });
          newValue[key] = ['all'];
        } else {
          const clearString = value.filter(val => typeof val === 'number');

          form.setFieldsValue({ [key]: clearString });
          newValue[key] = clearString;
        }
      }
    }

    handleFilterFormChange && handleFilterFormChange(newValue);
  };

  const tagRender = (props: any): JSX.Element => {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };

    return (
      <WrapperStatus>
        <OrderStatus
          fontSize="12px"
          label={label}
          padding={size === SIZE.SMALL ? '0px 7px' : ''}
          status={value}
          styles={{ 'line-height': size === SIZE.SMALL ? '18px' : '' }}
        />
        <WrapperIcon onClick={onClose} onMouseDown={onPreventMouseDown}>
          <CloseOutlined />
        </WrapperIcon>
      </WrapperStatus>
    );
  };

  return (
    <Form form={form} style={{ width }} onValuesChange={handleChangeFilter}>
      <WrapperFilter
        background={background}
        borderBottom={filterTagInfo ? false : borderBottom}
        isDisplayFilter={isDisplayFilter}
        padding={padding}
        width={width}
      >
        <Spacing size={spacing}>
          {data.map((item: DataItem, index: number) => {
            if (item.name === 'order') {
              return (
                <Form.Item
                  key={index}
                  name={item.name}
                  style={{ marginBottom: 0 }}
                >
                  <OrderTable
                    // width={filterWidth}
                    height={theme.select.height.sm}
                    list={item.list}
                  />
                </Form.Item>
              );
            }
            return (
              <Form.Item
                key={index}
                className="select-options"
                initialValue={item.list.length > 0 ? item.list[0].value : ''}
                name={item.name}
                style={{ marginBottom: 0 }}
              >
                <CSelect
                  disabled={item.disabled}
                  dropdownMatchSelectWidth={item.dropdownMatchSelectWidth}
                  dropdownStyle={item.dropdownStyle}
                  height="sm"
                  list={item.list}
                  loading={item?.loading != undefined ? item?.loading : false}
                  mode={item.mode}
                  placeholder={item.placeholder}
                  tagRender={tagRender}
                  width={
                    item.width
                      ? typeof item.width === 'number'
                        ? `${item.width}px`
                        : item.width
                      : item.mode === SELECT_MODE.MULTIPLE
                      ? `${filterStatusWidth}px`
                      : filterWidth
                  }
                />
              </Form.Item>
            );
          })}
          {extraFilter}
        </Spacing>
        {(extraAction != undefined || searchName != undefined) &&
          (data.length > 0 || extraFilter != undefined) && (
            <Space width={spacing} />
          )}
        <Spacing size={spacing}>
          {positionExtraAction == 'LEFT' ? <>{extraAction}</> : null}
          {searchName && (
            <Form.Item
              name={searchName || 'search'}
              style={{ marginBottom: 0 }}
            >
              <SearchTable
                height={size === SIZE.SMALL ? 'sm' : 'md'}
                placeholder={searchPlaceholder || `Tìm theo tên ${name}`}
                searchOnChange={searchOnChange}
                width={searchWidth}
              />
            </Form.Item>
          )}
          {positionExtraAction == 'RIGHT' ? <>{extraAction}</> : null}
        </Spacing>
      </WrapperFilter>
      {filterTagInfo && (
        <WrapperTagsFilter borderBottom={borderBottom}>
          <NameText color="main">{filterTagInfo.title}:</NameText>
          <Space width={spacing} />
          <GroupTag
            active={currentTags.includes('all')}
            margin={0}
            name="Tất cả"
            onClick={() => handleChooseTag('all')}
          />
          {filterTagInfo?.list?.map(item => (
            <GroupTag
              active={currentTags.includes(item.value)}
              margin={0}
              name={item.name}
              onClick={() => handleChooseTag(item.value)}
            />
          ))}
        </WrapperTagsFilter>
      )}
    </Form>
  );
};

export default FilterTable;
